<template>
    <div class="rateImg">
        <img src="../../assets/img/rate.png" alt="" srcset="">
    </div>
</template>

<script>
    export default {
        created () {
            document.title = '查看费率'
        },
    }
</script>

<style lang="scss" scoped>
.rateImg{
    margin-top: 20px;
}
.rateImg img{
    width: 100%;
}
</style>